<template>
  <div :style="{ position: 'relative', '--base-color': $theme.basecolor }">
    <button :style="selectStyle" :class="['btn-dropdown', selectClass]" @mouseup="toggleDropdown(null)">
      <span>{{ value.label }}</span>
      <flag v-if="flag" class="flag" :squared="false" :iso="value.icon" />
      <fa v-else :icon="[...value.icon.split(' ')]" />
    </button>
    <div ref="select_dropdown" class="dropdown" :hidden="!dropdown_open" tabindex="0" @blur="toggleDropdown(false)">
      <button v-for="opt of options" :key="opt[optionKey]" :style="optionStyle" :class="['dropdown-option', ...(last_selected === opt[optionKey] ? ['selected'] : []), optionClass]" @mousedown="select(opt)" @mouseenter="last_selected = opt[optionKey]">
        <span>{{ opt.label }}</span>
        <flag v-if="flag" class="flag" :squared="false" :iso="opt.icon" />
        <fa v-else-if="icon" :icon="[...opt.icon.split(' ')]" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CybSelect",
  props: {
    value: { type: Object, required: true },
    options: { type: Array, required: true },
    optionKey: { type: String, default: "id" },
    flag: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    selectStyle: { type: String, default: "" },
    selectClass: { type: String, default: "" },
    optionStyle: { type: String, default: "" },
    optionClass: { type: String, default: "" }
  },
  data() {
    return {
      dropdown_open: false,
      last_selected: ""
    };
  },
  mounted() {
    this.last_selected = this.value[this.optionKey];
  },
  methods: {
    toggleDropdown(override = null) {
      if (override) {
        this.dropdown_open = override;
        return;
      }

      this.dropdown_open = !this.dropdown_open;
      if (this.dropdown_open) {
        this.last_selected = this.options[0][this.optionKey];
        requestAnimationFrame(() => {
          this.$refs.select_dropdown.focus();
        });
      }
    },
    select(option) {
      this.dropdown_open = false;
      this.$emit("input", option);
      this.toggleDropdown(false);
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  all: unset;
  background: transparent;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
button.btn-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  border: 1px solid #3f3f3f;
}
.dropdown {
  position: absolute;
  outline: none;
  bottom: 0;
  right: 0;
  translate: 0 100%;
  z-index: 1000;
  min-width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.dropdown-option {
  padding: 0.125rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dropdown-option:hover,
.dropdown-option.selected {
  background-color: #00000011;
}
</style>
